import { FC } from 'react'

import OfferCard from './OfferCard'
import MarketplaceBanner from './MarketplaceBanner'
import { OfferSummary } from 'common/types/responses'
import { generateSrcSet } from 'project/image-proxy-web'
import { marketplaceStrings } from 'common/strings/marketplace-strings'

type StaffPicksOffersType = {
  offers: OfferSummary[]
}

const StaffPicksOffers: FC<StaffPicksOffersType> = ({ offers }) => {
  return (
    <>
      <div className={'mt-18'}>
        <div className='d-flex align-items-center justify-content-between'>
          <h4>{marketplaceStrings.staffPicks}</h4>
          {/* <span className='text-small-m text-link color-primary text-underline'>
            {marketplaceStrings.seeAll}
            <Icon
              name='chevron-right'
              height={12}
              width={12}
              fill='#1B71E3'
              className='ms-2'
            />
          </span> */}
        </div>
        <div className='row row-cols-1 row-cols-md-2 row-cols-lg-3 row-cols-xxl-4 mt-4'>
          {offers.map((offer) => (
            <div
              key={offer.id}
              className='col d-flex justify-content-center mb-4 mb-md-10 px-3'
            >
              <OfferCard titleOption={2} offerInfo={offer} />
            </div>
          ))}
        </div>
      </div>
      <div className='row align-items-stretch mt-md-22 my-4 mb-md-28'>
        <div className='col-md-6 mb-6 d-flex'>
          <MarketplaceBanner
            title={marketplaceStrings.weArepassionateAboutentrepreneurship}
            description={marketplaceStrings.businessPurposeStatement}
            imageContainerStyle={{
              width: '90%',
            }}
            backgroundColor='#E42692'
            image={
              <img
                className='position-absolute object-fit-contain max-w-100 h-100'
                {...generateSrcSet(
                  '/images/new/robot-holding-mail-v2.png',
                  240,
                  267,
                )}
                alt='plug-head-desktop'
              />
            }
          />
        </div>
        <div className='col-md-6 mb-6 d-flex'>
          <MarketplaceBanner
            title={marketplaceStrings.staffPicks2}
            description={marketplaceStrings.staffPicksStatement}
            backgroundColor='#3E2155'
            imageContainerStyle={{
              width: '100%',
            }}
            image={
              <img
                className='position-absolute object-fit-cover object-position-right max-w-100 h-100'
                {...generateSrcSet(
                  '/images/new/robot-arm-mail-zoomed-v2.png',
                  323,
                  250,
                )}
                alt='plug-head-desktop'
              />
            }
          />
        </div>
      </div>
    </>
  )
}

export default StaffPicksOffers
